import React, { useEffect, useRef } from 'react'
import { loginRequest } from '../authConfig'
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';

function AuthenticationService() {
    const { instance, accounts, inProgress } = useMsal();
    
    useEffect(() => {
        if (!accounts[0] && inProgress === "none") {
            instance.ssoSilent(loginRequest).catch(() => {
                // Redirect to login if SSO fails
            });
        }
    }, [accounts, inProgress, instance]);
    
    return null;
}

export default AuthenticationService